import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _get from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import classnames from 'classnames';
import { banOverScrollX } from '../utils/dom/scrollBehavior';
import { PureComponent } from '../component';
import { getParent } from '../utils/dom/element';
import normalizeWheel from '../utils/dom/normalizeWheel';
import { scrollClass } from './styles';
import Bar from './Bar';
import config from '../config';
import { Provider } from './context';
import { throttleWrapper } from '../utils/lazyload';
import { isRTL } from '../config';
export var BAR_WIDTH = 16;

var Scroll =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Scroll, _PureComponent);

  var _super = _createSuper2(Scroll);

  function Scroll(props) {
    var _this;

    _classCallCheck(this, Scroll);

    _this = _super.call(this, props);
    _this.baseScrollRatio = void 0;
    _this.touchStartX = void 0;
    _this.touchStartY = void 0;
    _this.wheelX = void 0;
    _this.wheelY = void 0;
    _this.pixelX = void 0;
    _this.pixelY = void 0;
    _this.cacheWidth = void 0;
    _this.cacheHeight = void 0;
    _this.wheelElement = void 0;
    _this.inner = void 0;
    _this.footerElement = void 0;
    _this.rmOverScrollListener = void 0;
    _this.touchStartX = 0;
    _this.touchStartY = 0;
    _this.wheelX = props.scrollX;
    _this.wheelY = props.scrollY;
    _this.pixelX = 0;
    _this.pixelY = 0;
    _this.cacheWidth = 0;
    _this.cacheHeight = 0;
    _this.bindInner = _this.bindInner.bind(_assertThisInitialized(_this));
    _this.bindWheel = _this.bindWheel.bind(_assertThisInitialized(_this));
    _this.bindFooter = _this.bindFooter.bind(_assertThisInitialized(_this));
    _this.setRect = _this.setRect.bind(_assertThisInitialized(_this));
    _this.handleScrollX = _this.handleScrollX.bind(_assertThisInitialized(_this));
    _this.handleScrollY = _this.handleScrollY.bind(_assertThisInitialized(_this));
    _this.handleWheel = _this.handleWheel.bind(_assertThisInitialized(_this));
    _this.bindIframe = _this.bindIframe.bind(_assertThisInitialized(_this));
    _this.handleTouchStart = _this.handleTouchStart.bind(_assertThisInitialized(_this));
    _this.handleTouchMove = _this.handleTouchMove.bind(_assertThisInitialized(_this));
    _this.setStartPoint = _this.setStartPoint.bind(_assertThisInitialized(_this));
    _this.handleInnerScroll = _this.handleInnerScroll.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Scroll, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      _get(_getPrototypeOf(Scroll.prototype), "componentDidMount", this).call(this);

      setTimeout(this.setRect);
      this.wheelElement.addEventListener('wheel', this.handleWheel, {
        passive: false
      });
      this.wheelElement.addEventListener('touchstart', this.handleTouchStart, {
        passive: true
      });
      this.wheelElement.addEventListener('touchmove', this.handleTouchMove, {
        passive: false
      });
      this.inner.addEventListener('scroll', this.handleInnerScroll);
      this.wheelElement.addEventListener('scroll', this.handleInnerScroll);
      this.rmOverScrollListener = banOverScrollX(this.wheelElement);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          stable = _this$props.stable,
          scrollWidth = _this$props.scrollWidth,
          scrollHeight = _this$props.scrollHeight;
      if (scrollWidth !== prevProps.scrollWidth) this.setRect();else if (stable && scrollHeight !== prevProps.scrollHeight) this.setRect();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _get(_getPrototypeOf(Scroll.prototype), "componentWillUnmount", this).call(this);

      this.wheelElement.removeEventListener('wheel', this.handleWheel);
      this.wheelElement.removeEventListener('touchstart', this.handleTouchStart);
      this.wheelElement.removeEventListener('touchmove', this.handleTouchMove);
      this.inner.removeEventListener('scroll', this.handleInnerScroll);
      this.wheelElement.removeEventListener('scroll', this.handleInnerScroll);

      if (this.footerElement) {
        this.footerElement.removeEventListener('wheel', this.handleWheel);
        this.footerElement.removeEventListener('touchstart', this.handleTouchStart);
        this.footerElement.removeEventListener('touchmove', this.handleTouchMove);
      }

      if (this.rmOverScrollListener) this.rmOverScrollListener();
    }
  }, {
    key: "getWheelRect",
    value: function getWheelRect() {
      if (!this.wheelElement) return {
        width: 0,
        height: 0
      };

      var _this$wheelElement$ge = this.wheelElement.getBoundingClientRect(),
          width = _this$wheelElement$ge.width,
          height = _this$wheelElement$ge.height; // display none


      if (width === 0 && height === 0) {
        width = this.cacheWidth;
        height = this.cacheHeight;
      } else {
        this.cacheWidth = width;
        this.cacheHeight = height;
      }

      var _this$props2 = this.props,
          scrollX = _this$props2.scrollX,
          scrollY = _this$props2.scrollY,
          _this$props2$style = _this$props2.style,
          style = _this$props2$style === void 0 ? {} : _this$props2$style;
      width = (typeof style.width === 'number' ? style.width : width) - (scrollY ? BAR_WIDTH : 0);
      height = (typeof style.height === 'number' ? style.height : height) - (scrollX ? BAR_WIDTH : 0);
      return {
        width: width,
        height: height
      };
    }
  }, {
    key: "setRect",
    value: function setRect() {
      this.handleScroll(this.props.left, this.props.top);
      this.forceUpdate();
    }
  }, {
    key: "setBaseScrollHeightRatio",
    value: function setBaseScrollHeightRatio(height) {
      if (this.baseScrollRatio) return;
      this.baseScrollRatio = 1;
      var ratio = config.scrollRatio; // windows scroll

      if (Math.abs(height) > 10) {
        this.baseScrollRatio = ratio / Math.abs(height);
      }
    }
  }, {
    key: "setStartPoint",
    value: function setStartPoint(position) {
      this.touchStartX = position.clientX;
      this.touchStartY = position.clientY;
    }
  }, {
    key: "bindInner",
    value: function bindInner(el) {
      this.inner = el;
    }
  }, {
    key: "bindIframe",
    value: function bindIframe(el) {
      if (el && el.contentWindow) {
        el.contentWindow.onresize = throttleWrapper(this.setRect);
      }
    }
  }, {
    key: "bindWheel",
    value: function bindWheel(el) {
      this.wheelElement = el;
    }
  }, {
    key: "bindFooter",
    value: function bindFooter(el) {
      if (this.footerElement) {
        this.footerElement.removeEventListener('wheel', this.handleWheel);
        this.footerElement.removeEventListener('touchstart', this.handleTouchStart);
        this.footerElement.removeEventListener('touchmove', this.handleTouchMove);
      }

      if (el) {
        el.addEventListener('wheel', this.handleWheel, {
          passive: false
        });
        el.addEventListener('touchstart', this.handleTouchStart, {
          passive: true
        });
        el.addEventListener('touchmove', this.handleTouchMove, {
          passive: false
        });
      }

      this.footerElement = el;
    }
  }, {
    key: "boundleScroll",
    value: function boundleScroll() {
      /*
      this.locked = true
      this.scrollTimer = setTimeout(() => {
        this.locked = false
        if (this.pixelX !== 0 || this.pixelY !== 0) {
          this.boundleScroll()
        }
      }, 32)
      */
      // lock direction
      if (Math.abs(this.pixelX) > Math.abs(this.pixelY)) {
        this.pixelY = 0;
      } else {
        this.pixelX = 0;
      }

      var _this$props3 = this.props,
          left = _this$props3.left,
          top = _this$props3.top;
      var _this$props4 = this.props,
          _this$props4$scrollWi = _this$props4.scrollWidth,
          scrollWidth = _this$props4$scrollWi === void 0 ? Scroll.defaultProps.scrollWidth : _this$props4$scrollWi,
          _this$props4$scrollHe = _this$props4.scrollHeight,
          scrollHeight = _this$props4$scrollHe === void 0 ? Scroll.defaultProps.scrollHeight : _this$props4$scrollHe;
      var x = left + this.pixelX / scrollWidth;
      if (x < 0) x = 0;
      if (x > 1) x = 1;
      var y = top + this.pixelY / scrollHeight;
      if (y < 0) y = 0;
      if (y > 1) y = 1;

      if (x !== left || y !== top) {
        this.handleScroll(x, y, this.pixelX, this.pixelY);
      }

      this.pixelX = 0;
      this.pixelY = 0;
    }
  }, {
    key: "handleWheel",
    value: function handleWheel(event) {
      var scrollX = this.wheelX;
      var scrollY = this.wheelY;
      var _this$props$innerScro = this.props.innerScrollAttr,
          innerScrollAttr = _this$props$innerScro === void 0 ? Scroll.defaultProps.innerScrollAttr : _this$props$innerScro;
      if (!scrollX && !scrollY) return;
      var wheelTarget = event.target;

      if (innerScrollAttr.find(function (attr) {
        return wheelTarget.hasAttribute(attr);
      })) {
        event.stopPropagation();
        return;
      }

      var target = getParent(wheelTarget, ".".concat(scrollClass('_')));
      var inFooter = false;

      if (this.footerElement) {
        inFooter = this.footerElement === event.target || this.footerElement.contains(wheelTarget);
      }

      if (target !== this.wheelElement && !inFooter) return;
      var wheel = normalizeWheel(event);
      this.setBaseScrollHeightRatio(wheel.pixelY);
      if (scrollX) this.pixelX = isRTL() ? this.pixelX - wheel.pixelX : this.pixelX + wheel.pixelX;
      if (scrollY && !inFooter) this.pixelY += wheel.pixelY * this.baseScrollRatio;

      if (Math.abs(wheel.pixelX) > Math.abs(wheel.pixelY)) {
        event.preventDefault();
      } else if (scrollY) event.preventDefault(); // if (!this.locked) {


      this.boundleScroll(); // }
    }
  }, {
    key: "handleScroll",
    value: function handleScroll(x, y, pixelX, pixelY) {
      var _ref = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {},
          drag = _ref.drag;

      var _this$props$scrollWid = this.props.scrollWidth,
          scrollWidth = _this$props$scrollWid === void 0 ? Scroll.defaultProps.scrollWidth : _this$props$scrollWid;

      var _this$getWheelRect = this.getWheelRect(),
          width = _this$getWheelRect.width,
          height = _this$getWheelRect.height;

      var max = Math.round((1 - width / scrollWidth) * scrollWidth);

      if (this.props.onScroll) {
        this.props.onScroll(x, y, max, this.inner, width, height, pixelX, pixelY, drag);
      }
    }
  }, {
    key: "handleScrollX",
    value: function handleScrollX(left) {
      this.handleScroll(left, this.props.top, undefined, 0, {
        drag: true
      });
    }
  }, {
    key: "handleScrollY",
    value: function handleScrollY(top) {
      this.handleScroll(this.props.left, top, undefined, undefined, {
        drag: true
      });
    }
  }, {
    key: "handleTouchStart",
    value: function handleTouchStart(e) {
      this.setStartPoint(e.changedTouches[0]);
    }
  }, {
    key: "handleTouchMove",
    value: function handleTouchMove(e) {
      var _this$props5 = this.props,
          scrollX = _this$props5.scrollX,
          scrollY = _this$props5.scrollY;
      e.preventDefault();
      var position = e.changedTouches[0];
      var moveX = position.clientX - this.touchStartX;
      var moveY = position.clientY - this.touchStartY;
      if (scrollX) this.pixelX = -moveX;
      if (scrollY) this.pixelY = -moveY; // need reset the start

      this.setStartPoint(position);
      this.boundleScroll();
    } // handle inner scroll cased by input focus

  }, {
    key: "handleInnerScroll",
    value: function handleInnerScroll(e) {
      var _ref2 = e,
          target = _ref2.target;
      var _this$props6 = this.props,
          _this$props6$scrollWi = _this$props6.scrollWidth,
          scrollWidth = _this$props6$scrollWi === void 0 ? Scroll.defaultProps.scrollWidth : _this$props6$scrollWi,
          _this$props6$scrollHe = _this$props6.scrollHeight,
          scrollHeight = _this$props6$scrollHe === void 0 ? Scroll.defaultProps.scrollHeight : _this$props6$scrollHe,
          left = _this$props6.left,
          top = _this$props6.top;

      var _this$getWheelRect2 = this.getWheelRect(),
          width = _this$getWheelRect2.width,
          height = _this$getWheelRect2.height;

      if (target.scrollLeft || target.scrollTop) {
        var sLeft = target.scrollLeft ? left + target.scrollLeft / (scrollWidth - width) : left;
        var sTop = target.scrollTop ? top + target.scrollTop / (scrollHeight - height) : top;
        sTop = Math.min(1, sTop);
        sTop = Math.max(0, sTop);
        sLeft = Math.min(1, sLeft);
        sLeft = Math.max(0, sLeft);
        this.handleScroll(sLeft, sTop, undefined, undefined, {
          drag: true
        });
        target.scrollLeft = 0;
        target.scrollTop = 0;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props7 = this.props,
          _this$props7$scrollWi = _this$props7.scrollWidth,
          scrollWidth = _this$props7$scrollWi === void 0 ? Scroll.defaultProps.scrollWidth : _this$props7$scrollWi,
          _this$props7$scrollHe = _this$props7.scrollHeight,
          scrollHeight = _this$props7$scrollHe === void 0 ? Scroll.defaultProps.scrollHeight : _this$props7$scrollHe,
          children = _this$props7.children,
          left = _this$props7.left,
          top = _this$props7.top,
          scrollX = _this$props7.scrollX,
          scrollY = _this$props7.scrollY,
          style = _this$props7.style;

      var _this$getWheelRect3 = this.getWheelRect(),
          width = _this$getWheelRect3.width,
          height = _this$getWheelRect3.height;

      var rtl = isRTL();
      var className = classnames(scrollClass('_', scrollX && 'show-x', scrollY && 'show-y', rtl && 'rtl'), this.props.className);
      var yLength = scrollHeight < height ? scrollHeight : height;
      this.wheelY = scrollY && Math.ceil(scrollHeight) > Math.ceil(yLength);
      this.wheelX = scrollX && Math.ceil(scrollWidth) > Math.ceil(width);
      return (
        /*#__PURE__*/
        React.createElement(React.Fragment, null,
        /*#__PURE__*/
        React.createElement("div", {
          style: style,
          ref: this.bindWheel,
          className: className
        },
        /*#__PURE__*/
        React.createElement("iframe", {
          tabIndex: -1,
          title: "scroll",
          ref: this.bindIframe,
          className: scrollClass('iframe')
        }),
        /*#__PURE__*/
        React.createElement("div", {
          className: scrollClass('iframe')
        }),
        /*#__PURE__*/
        React.createElement("div", {
          ref: this.bindInner,
          className: scrollClass('inner')
        },
        /*#__PURE__*/
        React.createElement(Provider, {
          value: {
            left: left * width,
            top: top * height,
            element: this.wheelElement
          }
        }, children)), scrollY &&
        /*#__PURE__*/
        React.createElement(Bar, {
          direction: "y",
          length: yLength,
          forceHeight: scrollHeight < height ? scrollHeight : undefined,
          scrollLength: scrollHeight,
          offset: top,
          onScroll: this.handleScrollY
        }), scrollX &&
        /*#__PURE__*/
        React.createElement(Bar, {
          direction: "x",
          length: width,
          scrollLength: scrollWidth,
          offset: left,
          onScroll: this.handleScrollX
        })), this.props.footer &&
        /*#__PURE__*/
        React.createElement("div", {
          ref: this.bindFooter,
          className: scrollClass('footer')
        }, this.props.footer))
      );
    }
  }]);

  return Scroll;
}(PureComponent);

Scroll.defaultProps = {
  scrollHeight: 0,
  scrollWidth: 0,
  innerScrollAttr: []
};
export default Scroll;